import React, { useCallback, useState } from "react";
import { useAddProtocol } from "../../../data/mutations/useAddProtocol";
import { Button } from "../Button";
import { Dialog } from "../Dialog";
import { Fieldset } from "../Fieldset";
import { Form } from "../Form";
import { Label } from "../Label";
import { Textarea } from "../Textarea";
import { TextInput } from "../TextInput";

type CreateProtocolDialogProps = {
  open: boolean;
  onOpenChange: (value: boolean) => void;
};

export const CreateProtocolDialog = ({ open, onOpenChange }: CreateProtocolDialogProps) => {
  const [addProtocol] = useAddProtocol();
  const [protocolName, setProtocolName] = useState<string>("");
  const [protocolDescription, setProtocolDescription] = useState<string>("");

  const onProtocolSave = useCallback(
    (protocolName, protocolDescription) => {
      addProtocol({ variables: { name: protocolName, description: protocolDescription } });
    },
    [addProtocol],
  );

  const emptyProtocolFormData = useCallback(() => {
    setProtocolName("");
    setProtocolDescription("");
  }, []);

  return (
    <Dialog.Dialog
      open={open}
      onOpenChange={() => {
        emptyProtocolFormData();
        onOpenChange(!open);
      }}>
      <Dialog.Content>
        <Dialog.Title>Create protocol</Dialog.Title>
        <Dialog.Description>{`Create a new protocol. Click save when you're done.`}</Dialog.Description>
        <div className={"mt-5"}>
          <Form>
            <Fieldset>
              <Label htmlFor="name">Name</Label>
              <TextInput
                id="name"
                value={protocolName}
                onValueChange={(e) => {
                  setProtocolName(e.currentTarget.value);
                }}
              />
            </Fieldset>
            <Fieldset>
              <Label htmlFor="description">Description</Label>
              <Textarea
                id="description"
                value={protocolDescription}
                onValueChange={(e) => {
                  setProtocolDescription(e.currentTarget.value);
                }}
              />
            </Fieldset>
          </Form>
        </div>
        <Dialog.Footer>
          <Dialog.Close>
            <Button
              variant="primary"
              text="Save protocol"
              onClick={() => {
                onProtocolSave(protocolName, protocolDescription);
                emptyProtocolFormData();
              }}
            />
          </Dialog.Close>
          <Dialog.Close>
            <Button
              variant="plain"
              text="Cancel"
              onClick={() => {
                emptyProtocolFormData();
              }}
            />
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Dialog>
  );
};
